export function LoadingState({ message = "Loading…" }: { message?: string }) {
  return <p className="text-muted-foreground">{message}</p>;
}

export function ErrorState({ message }: { message: string }) {
  return <p className="text-destructive">{message}</p>;
}
